import {
  useWSModalCustom,
  useWSSnackbar,
  WSForm,
  WSInputText,
  WSList,
  WSModal,
  WSModalCustomProps
} from "@wingspanhq/fe-component-library";
import { WorkDefinition, WorkItem } from "@wingspanhq/wingspan-api-sdk";
import * as Yup from "yup";
import { queriesWorkItems } from "@query";
import { ErrorAlert } from "@components/ErrorAlert";
import { FormPartialAttributes } from "../../components/FormPartialAttributes";
import { AcceptedValuesResources } from "../../components/FormPartialAttributes/helpers";
import { PublicCommentField } from "../../components/PublicCommentField";

type Props = {
  workItem: WorkItem;
  workDefinition: WorkDefinition;
  resources: AcceptedValuesResources;
  contractorName?: string;
} & WSModalCustomProps<any>;

const validationSchema = Yup.object().shape({
  comment: Yup.string().required("A comment is required to remove an item")
});

export const ModalRemoveItemPayer: React.FC<Props> = ({
  workItem,
  workDefinition,
  resources,
  contractorName,
  ...modalProps
}) => {
  const [mutate, meta] = queriesWorkItems.deleteWorkItem.useMutation();

  const { openSnackbar } = useWSSnackbar();

  const commentDescription = contractorName
    ? `Comment is visible to both you and the contractor. Please provide specific details that will inform ${contractorName} about the edits.`
    : "Comment is visible to both you and the contractor. Please provide specific details about the edits.";

  return (
    <WSForm
      defaultValues={{ comment: "" }}
      validationSchema={validationSchema}
      onSubmit={({ comment }) => {
        mutate(
          {
            workItemId: workItem.id!,
            workItemDelete: { payerOwnedData: { comment } }
          },
          {
            onSuccess: () => {
              modalProps.onClose(undefined);

              openSnackbar({
                icon: {
                  name: "check"
                },
                message: "Work item removed"
              });
            },
            onError: () => {
              openSnackbar({
                icon: {
                  name: "alert-circle"
                },
                message: "Failed to remove work item"
              });
            }
          }
        );
      }}
    >
      <WSModal
        title="Remove item"
        actions={{
          alignment: "fill",
          buttons: [
            {
              kind: "Secondary",
              label: "Cancel",
              type: "button",
              onClick: () => {
                modalProps.onClose(undefined);
              }
            },
            {
              kind: "Primary",
              destructive: true,
              label: "Remove work item",
              loading: meta.isLoading
            }
          ]
        }}
        {...modalProps}
      >
        <WSList gap="L">
          <WSInputText
            disabled
            label="Work type"
            required
            value={workDefinition.name || ""}
            onChange={() => {}}
          />

          <FormPartialAttributes
            disabled
            attributeDefinitions={workDefinition.attributeDefinitions ?? []}
            resources={resources}
          />

          <PublicCommentField
            label="Comment *"
            description={commentDescription}
            placeholder="Provide specific details about the edits"
          />

          <ErrorAlert error={meta.error} context="WorkItem" />
        </WSList>
      </WSModal>
    </WSForm>
  );
};
export const useModalRemoveItemPayer = () =>
  useWSModalCustom(ModalRemoveItemPayer);
